// import React from 'react';

// import { Provider } from 'react-redux';
// import { Switch, HashRouter } from 'react-router-dom';

// import configureStore from './store';
// import Route from './app/routes';

// export const store = configureStore();

// const App = () =>
//     <Provider store={store}>
//         <HashRouter>
//             <Switch>
//                 <Route />
//             </Switch>
//         </HashRouter>
//     </Provider>;

// export default App;

import React from 'react';

import { Provider } from 'react-redux';
import { Switch, HashRouter } from 'react-router-dom';
import createHistory from 'history/createMemoryHistory';
import configureStore from './store';
import Route from './app/routes';
import {ConnectedRouter} from 'connected-react-router';

const history = createHistory();
const store = configureStore(history);
const App = () =>

    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route />
            </Switch>
            </ConnectedRouter>
    </Provider>;

export default App;
